import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon } from '@economic/gaudi';

import { t } from '../../../shared/components/l10n/l10n';
import { UpgradeToPlanResult } from './shared';
import successSpot from './success.png';

interface Props {
    result: UpgradeToPlanResult;
    onClose: () => void;
}

export function PlanSuccessPage({ result, onClose }: Props) {
    return (
        <div className="flex flex-col items-center -m-6 mt-6 text-center">
            <h1>{t`SUBSCRIPTIONSTATUS_FINISHED_HURRA`}</h1>

            <img src={successSpot} alt="" />
            <p className="p-6">
                {result.confirmedText} {result.billingInformationText}
            </p>

            <Button appearance="primary" onClick={onClose} className="mb-6 min-w-0 w-100">
                {t`SUBSCRIPTIONSTATUS_FINISHED_CONTINUE`}
            </Button>

            <div className="bg-white p-6 w-full flex text-left">
                <Icon name="market" className="mr-3 self-start " />
                <p>
                    {t`SUBSCRIPTIONSTATUS_MARKETPANEL_TEXT`}{' '}
                    <Link to="/market">{t`SUBSCRIPTIONSTATUS_MARKETPANEL_READMORELINK`}</Link>
                </p>
            </div>
        </div>
    );
}
